import type { GameKindAdapter } from "../shared/adapter";
import { compilePaddleDuel } from "./compiler";
import { evaluatePaddleDuel } from "./evaluator";
import { repairCommandsForPaddleDuel } from "./repair";
import { parsePaddleDuelSpec, type PaddleDuelSpec } from "./spec";

export const paddleDuelAdapter: GameKindAdapter = {
  kind: "paddle-duel",
  briefHints: ["pong", "tennis", "air hockey", "paddle", "volley", "one-on-one rally", "two player", "vs my friend", "party game"],
  promptSchemaLine:
    '{"kind":"paddle-duel","params":{"arenaWidth":960,"arenaHeight":540,"paddleHeight":integer 60-220,"ballSpeed":integer 220-600,"aiSpeed":integer 90-420,"pointsToWin":integer 1-9,"players":1 or 2 (2 = local two-player, one paddle per side of the touchscreen -- use it when the brief says two player, versus, with my friend, or party)}}',
  parseSpec: parsePaddleDuelSpec,
  compile: (spec) => compilePaddleDuel(spec as PaddleDuelSpec),
  evaluate: (spec) => evaluatePaddleDuel(spec as PaddleDuelSpec),
  repairCommandsFor: (spec, failedReceipt) => repairCommandsForPaddleDuel(spec as PaddleDuelSpec, failedReceipt),
};

export type { PaddleDuelSpec } from "./spec";
